import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Config } from '../../../config/config';

@Injectable()
export class XlXuLySuCoService {

    constructor(private http: Http) { }

    ds_PhanAnhChoDong(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_PhanAnhChoDong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh(XL, type) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/GetReportData?type=${type}`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh_MoRong(XL, type) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/GetReportDataExt?type=${type}`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Dem_SoLuong_PhanAnh(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/CountReportData`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Dem_SoLuong_PhanAnh_Ext(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/CountReportDataExt`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh1(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/DS_CHO_XULY`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh2(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/DS_CHO_DANGTAI`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh3(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/DS_DA_XULY`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh4(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/DS_CHO_PHEDUYET`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_PhanAnh5(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + `XLXuLy/DS_PHANANH_TUONGTAC`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLy_New(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLy_New', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_PhieuChoXuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLyHeThong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLyCount(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLyCount', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLyHeThong() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'XLXuLy/GetListCountHeThong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_YeuCauChucXuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_YeuCauChuaXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_YeuCauChucXuLy_TT(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_YeuCauChuaXuLy_TT', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_CanhBao() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {}
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_CanhBao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLyLichSu(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLyLichSu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLyLichSuIgate(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLyLichSuIgate', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ct_LichSuXuLyBuocTruoc(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/ct_LichSuXuLyBuocTruoc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Ds_XuLyLichSuXacNhanDong(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLyLichSuXacNhanKQ', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_AnhYeuCauVaXuLy(id, loai) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + 'XLXuLy/ds_AnhYeuCauVaXuLy?Id=' + id +"&Loai=" + loai, { headers: headers }).map(resp => resp.json());
    }
    DanhSach_TapTinXuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_TapTinXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_TapTinYeuCau(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'XLXuLy/GetDSFile', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_ThietBiSanPham(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_ThietBiSanPham', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Gui_Email(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'XLXuLy/GuiEmail', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Tao_XuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/Save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    SaveUploadFile(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/UploadFile', formData, { headers: headers }).map(resp => resp.json());
    }
    SaveUploadFileNew(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/UploadFileNew', formData, { headers: headers }).map(resp => resp.json());
    }
    DownloadFileYeuCau(filename) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMXuLyYeuCau/DownloadFile?filename=' + filename, { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
    DownloadFilePAHT(filename) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'APIPAHT/Get_File?f=' + filename, { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
    Gui_TinNhan(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;
        return this.http.post(Config.apiUrl + 'SMSSend/sMSBrandName', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    sMSCanhBaoChiDao(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;
        return this.http.post(Config.apiUrl + 'SMSSend/sMSCanhBaoChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLyHoTro(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_HoTro', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }    
    DanhSach_Sensors(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/Prtg_Sensor_Channel', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ChiTiet_Sensors(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/Prtg_Sensor_Detail', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Tao_SuCo(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/SaveSuCo', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_XuLyNhomSuCo(IdSanPham) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));    
        let data  = {IdSanPham:IdSanPham}; 
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_NhomSuCo', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_ChiDao(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSachChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_ChiDaoBuoc(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/GetListChiDaoBuoc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_NhomCoQuan_Loai(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_NhomCoQuan_Loai', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Tao_BaoCaoNangCap(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/Luu_BaoCaoNangCap', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_SanPham_CoQuanXuLy() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_SanPham_CoQuanXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListSPByCoQuan(idCoQuan:number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + "XLXuLy/GetListSPByCoQuan?idCoQuan=" + idCoQuan, { headers: headers }).map(resp => resp.json());
    }
    ds_DiaBanTinhThanh(idNhanVien:number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + "XLXuLy/ds_DiaBanTinhThanh?idNhanVien=" + idNhanVien, { headers: headers }).map(resp => resp.json());
    }
    DanhSach_NhomCoQuan_Buoc(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_NhomCoQuan_Buoc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Luu_ChuyenQuyTrinh(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/Luu_ChuyenQuyTrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_CoQuan_YeuCau() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_CoQuan_YeuCau', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_KetQuaXuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_KetQuaXuLyBuoc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_KetQuaXuLyDH(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_KetQuaXuLyBuocDH', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_BuocThucHien_KetQuaXuLy(BKQXL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = BKQXL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_BuocThucHien_KetQuaXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_MucDoNangCap(IdLoai:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {NangCap:IdLoai};
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListMucDo',JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    DownloadFile(filename){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'XLXuLy/DownloadFile?filename=' + filename, { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }    
    DownloadFileLichSu(filename){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            FileName:filename
        }
        return this.http.post(Config.apiUrl + 'XLXuLy/DownloadFileLichSu',JSON.stringify(data), { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
    ConvertToPDF(filename){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = filename;  
        return this.http.post(Config.apiUrl + 'XLXuLy/ExportWorkbookToPdf', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DocConvertToPDF(filename){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = filename;  
        return this.http.post(Config.apiUrl + 'XLXuLy/ExportDocToPdf', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DS_NhanVienGiaoViec(GV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = GV;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DSNhanVienGiaoViec', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DS_NhanVienPhanCongXuLy() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};        
        return this.http.post(Config.apiUrl + 'XLXuLy/DSNhanVienPhanCongXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DS_FilesGiaoViec(GV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = GV;        
        return this.http.post(Config.apiUrl + 'XLXuLy/DSFilesGiaoViec', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    BaoCaoNoiDung(BC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = BC;        
        return this.http.post(Config.apiUrl + 'XLXuLy/BaoCaoNoiDung', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Luu_GiaoViecNhanVien(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/uploadFileGiaoViec', formData, { headers: headers }).map(resp => resp.json());
    }
   
    Luu_BaoCaoGiaoViec(formData: FormData) {
        let headers = new Headers();        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/uploadFileBaoCaoGiaoViec', formData, { headers: headers }).map(resp => resp.json());
    }
    Luu_DuyetBaoCao(XBC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XBC;        ;
        return this.http.post(Config.apiUrl + 'XLXuLy/Luu_DuyetBaoCao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_FileXuLy(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_FileXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    XuatExcel(idyeucau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/ExcelLichSu',JSON.stringify({IdYeuCau:idyeucau}), { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
    ct_KiemTraDieuHuong(idyeucau: number, idcoquan: number, capdieuhuong:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
          IdYeuCau: idyeucau,
          IdCoQuan:idcoquan,
          CapDieuHuong:capdieuhuong
        };
        return this.http.post(Config.apiUrl + 'XLXuLy/ct_KiemTraChuoiDieuHuong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_GiaiPhap(idbuoc, op) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdBuoc:idbuoc,
            Op:op
        };
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_GiaiPhap', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_BuocGiaiPhap(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_BuocGiaiPhap', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_PhieuXuLySong(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_PhieuXuLySong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_TrangThaiPhieu(idbuoc, op) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdBuoc:idbuoc,
            Op:op
        };
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_TrangThaiPhieu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_BuocTrangThaiPhieu(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_BuocTrangThaiPhieu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_CapNhatTrangThaiPhieu(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_CapNhatTrangThaiPhieu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_CapNhatTrangThaiPhieuFile(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/uploadFileDongXacNhan', formData, { headers: headers }).map(resp => resp.json());
    }
    ds_BtsCells(idphuongxa) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));       
        return this.http.post(Config.apiUrl + 'APIRims/GetInfoRims?idPhuongXa='+idphuongxa, { headers: headers }).map(resp => resp.json());
    }
    phanHoi_Ccos(idyeucau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));       
        return this.http.post(Config.apiUrl + 'APICOSS/ChuyenKhieuNai?idyeucau='+idyeucau, { headers: headers }).map(resp => resp.json());
    }    
    phanHoi_Ccos1(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'APICOSS/ChuyenKhieuNai', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_TramRims(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_tramrims', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_PhanCongXuLy(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_PhanCongXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_CapNhatDiaBan(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_CapNhatDiaBan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    XuatExcelYeuCauChuaXuLy(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/ExcelYeuCauChuaDong',JSON.stringify(data), { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
    luu_CapNhatQuyTrinh(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_CapNhatTrangThaiPhieu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    phanHoi_PMS(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'APIPMS/PhanHoiPMS', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    phanHoi_FMS(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'APIFMS/PhanHoiFMS', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    phanHoi_CTS(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'APICTS/PhanHoiCTS', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_ChiTietSoLanGoi(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_ChiTietSoLanGoi', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_NhanVienChiDao(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;        
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_NhanVienChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Luu_FileChiDao(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/uploadFileChiDao', formData, { headers: headers }).map(resp => resp.json());
    }
    ds_CSHTTHIETBI(Loai:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Loai:Loai};    
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_CSHTTB', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_CapNhatTienDoCSHTTB(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/Luu_CapNhatTienDoXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ct_TienDoXuLyCSHTTB(idXuLy:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdXuLy:idXuLy};    
        return this.http.post(Config.apiUrl + 'XLXuLy/ct_TienDoChuanBiCSHTTB', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_MacroKeHoach() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};    
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_MacroKeHoach', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    huy_PhanAnh(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/huy_PhanAnh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_ThayDoiLinhVuc(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/Luu_ThayDoiLinhVuc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_PhanAnhTuongTacMoi(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;    
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_PhanAnhTuongTacMoi', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_BinhLuan(idYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdYeuCau:idYeuCau
        };    
        return this.http.post(Config.apiUrl + 'XLXuLy/ds_BinhLuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    getCommentList(idYeuCau, keyword='') {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdYeuCau:idYeuCau
        };    
        return this.http.get(Config.apiUrl + `comment/getlist?id=${idYeuCau}&keyword=${keyword}`, { headers: headers }).map(resp => resp.json());
    }
    getCommentList1(idYeuCau, keyword='') {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdYeuCau:idYeuCau
        };    
        return this.http.get(Config.apiUrl + `comment/CommentList1?id=${idYeuCau}&keyword=${keyword}`, { headers: headers }).map(resp => resp.json());
    }
    getCommentList2(idYeuCau, keyword='') {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdYeuCau:idYeuCau
        };    
        return this.http.get(Config.apiUrl + `comment/CommentList2?id=${idYeuCau}&keyword=${keyword}`, { headers: headers }).map(resp => resp.json());
    }
    replyComment(id, idCha, noidung) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            id: id,
            idCha: idCha,
            noiDung: noidung
        };
        return this.http.post(Config.apiUrl + `comment/reply`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    updateComment(id, noidung) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            id: id,
            noiDung: noidung
        };
        return this.http.post(Config.apiUrl + `comment/update`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    deleteComment(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken")); 
        return this.http.post(Config.apiUrl + `comment/delete?id=${id}`, null, { headers: headers }).map(resp => resp.json());
    }
    HideComment(id,hide) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken")); 
        return this.http.post(Config.apiUrl + `comment/hide?id=${id}&hide=${hide}`, null, { headers: headers }).map(resp => resp.json());
    }
    luu_DuyetBinhLuan(data){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/Luu_DuyetBinhLuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Luu_TraLoiBinhLuan(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'APIPAHT/traoDoiThongTin', formData, { headers: headers }).map(resp => resp.json());
    }
    CapNhat_TraLoiBinhLuan(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'APIPAHT/traoDoiThongTinCapNhat', formData, { headers: headers }).map(resp => resp.json());
    }
    lay_BinhLuan(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + 'APIPAHT/lay_binh_luan?Id=' + data, { headers: headers }).map(resp => resp.json());        
    }
    luu_XacNhanDong(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_XacNhanDong', formData, { headers: headers }).map(resp => resp.json());
    }
    luu_XacNhanDongIgate(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'XLXuLy/luu_XacNhanDongIgate', JSON.stringify(data), { headers: headers }).map(resp => resp.json());        
    }
    xoa_PhanAnh(IdYeuCau) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));     
        return this.http.get(Config.apiUrl + 'XLXuLy/xoa_phan_anh?IdYeuCau=' + IdYeuCau, { headers: headers }).map(resp => resp.json());        
    }

    khoiphuc_PhanAnh(IdYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + 'XLXuLy/khoi_phuc_phan_anh?IdYeuCau=' + IdYeuCau, { headers: headers }).map(resp => resp.json());        
    }

    xoavinhvien_PhanAnh(IdYeuCau) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));     
        return this.http.get(Config.apiUrl + 'XLXuLy/xoa_vinh_vien_phan_anh?IdYeuCau=' + IdYeuCau, { headers: headers }).map(resp => resp.json());        
    }

    DanhSach_GhiChu(IdYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XLXuLy/lay_danh_sach_ghi_chu', IdYeuCau, { headers: headers }).map(resp => resp.json());
    }

    ChiTiet_GhiChu(IdGhiChu) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'XLXuLy/lay_chi_tiet_ghi_chu?idGhiChu=' + IdGhiChu, { headers: headers }).map(resp => resp.json());
    }

    Xoa_GhiChu(IdGhiChu) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'XLXuLy/xoa_ghi_chu?idGhiChu=' + IdGhiChu, { headers: headers }).map(resp => resp.json());
    }

    Them_GhiChu(XL) {      
        console.log("XL", XL);
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/them_ghi_chu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DanhSacPhanAnhTuongTac(XL) {
        console.log("XL", XL);
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_PhanAnh_TuongTac', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DanhSach_XuLy2(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_XuLy2', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DS_NguonPA() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +"TonghopDanhgia/DS_NguonPA", { headers: headers }).map(resp => resp.json());       
    }
    GetReportInfo(id:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + "XLXuLy/GetReportInfo?id=" + id, { headers: headers }).map(resp => resp.json());
    }

    ChiTiet_PhanAnh(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + `XLXuLy/GetReportDetail`, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/xu-ly/xl-xu-ly-su-co/xl-xu-ly-su-co.service.ts